import moment from "moment";
import { NumericFormat } from 'react-number-format';

const formatDateYMD = (date) => {
    let formatDate = moment(date).format("YYYY-MM-DD");
    return formatDate;
};

const formatDateTime = (datetime) => {
    const datetimeValue = new Date(datetime);
    //return datetimeValue.toLocaleString();

    let hours = datetimeValue.getHours();
    let minutes = datetimeValue.getMinutes();
    const apm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${datetimeValue.toLocaleDateString()} ${hours}:${minutes}${apm}`;
};

const formatLongDate = (datetime) => {
    let today = new Date(datetime);
    let date = String(today.getDate()).padStart(2, '0');
    let month = today.toLocaleString('default', { month: 'long' });
    let year = today.getFullYear();
    let longDate = date + " " + month + " " + year;
    return longDate;
}

const parseToLocale = datetime => {
    const datetimeValue = new Date(datetime);
    // console.log(datetimeValue.getFullYear());
    // console.log(datetimeValue.getMonth());
    // console.log(datetimeValue.getDate());
    // console.log(datetimeValue.getHours() + ':00:00');
    // console.log('------- ');

    let month = datetimeValue.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let date = datetimeValue.getDate();
    if (date < 10) date = '0' + date;
    let hour = datetimeValue.getHours()
    if (hour < 10) hour = '0' + hour;
    hour += ':00:00';
    return {
        datePart: `${datetimeValue.getFullYear()}-${month}-${date}`,
        timePart: hour
    };
}

const formatDate = (datetime) => {
    const datetimeValue = new Date(datetime);
    return `${datetimeValue.toLocaleDateString()}`;
};

const categoryOptions = (categories) => {
    const categoryList = categories.map(c => c.category);
    return categoryList;
};

const typeOptions = (categories, category) => {
    let typeList = [];
    const selectedCategories = categories.filter(c => c.category === category);
    if (selectedCategories.length > 0) {
        typeList = selectedCategories[0].types
    }
    return typeList;
};

const countryOptions = (countries) => {
    const countryList = countries.map(c => c.country);
    return countryList;
};

const stateOptions = (countries, country) => {
    let statesList = [];
    const selectedCountry = countries.filter(c => c.country === country);
    if (selectedCountry.length > 0) {
        statesList = selectedCountry[0].states.map(s => s.state);
    }
    return statesList;
};

const areaOptions = (countries, country, state) => {
    let final = {};
    let areaList = [];
    const selectedCountry = countries.filter(c => c.country === country);
    if (selectedCountry.length > 0) {
        const selectedState = selectedCountry[0].states.filter(s => s.state === state);
        if (selectedState.length > 0) {
            areaList = selectedState[0].areas;
        }
    }
    else {
        final.states = [];
    }
    final.areas = areaList;
    return final;
};

const formatCurrency = (n) => {
    // return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (
        <NumericFormat
            prefix={'RM '}
            displayType={"text"}
            decimalScale={"2"}
            fixedDecimalScale={true}
            thousandSeparator={true}
            value={n} />
    )
};

const fullAddress = (address) => {
    let fullAddress = '';
    if (address) {
        if (address.line1) fullAddress += (address.line1 + ', ');
        if (address.line2) fullAddress += (address.line2 + ', ');
        if (address.city) fullAddress += (address.city + ', ');
        if (address.postcode) fullAddress += (address.postcode + ', ');
        if (address.state) fullAddress += (address.state + ', ');
        if (address.country) fullAddress += address.country;
    }
    return (fullAddress.length > 15 ? fullAddress : undefined);
};

const displayLoc = loc => {
    if (loc && loc.coordinates) return `[${loc.coordinates[1]},${loc.coordinates[0]}]`;
    return `[0,0]`;
};

const bytes2String = fileSizeList => {
    let newFileSizes = [];
    fileSizeList.map((fileSize) => {
        if (fileSize < 1000) {
            fileSize = fileSize.toString() + " bytes";
        } else if (fileSize < 1000000) {
            fileSize =
                (fileSize / Math.pow(1024, 1))
                    .toString()
                    .match(/^-?\d+(?:\.\d{0,2})?/)[0] + " KB";
        } else {
            fileSize =
                (fileSize / Math.pow(1024, 2))
                    .toString()
                    .match(/^-?\d+(?:\.\d{0,2})?/)[0] + " MB";
        }
        newFileSizes.push(fileSize);
    });
    console.log(newFileSizes)
    return newFileSizes
}

const log = (val) => {
    if (process.env.REACT_APP_DEV_MODE === `true`)
        console.log(val);
};

const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const formatCurrencyWithComma = (num) => {
    var p = num.toFixed(2).split(".");
    return "RM " + p[0].split("").reverse().reduce((acc, num, i, orig) => {
        return num + (num != "-" && i && !(i % 3) ? "," : "") + acc;
    }, "") + "." + p[1];
}

const formatDateToCustomString = (date) => {
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  } 

export default {
    formatDateYMD: formatDateYMD,
    formatDate: formatDate,
    formatDateTime: formatDateTime,
    formatLongDate: formatLongDate,
    parseToLocale: parseToLocale,
    categoryOptions: categoryOptions,
    typeOptions: typeOptions,
    countryOptions: countryOptions,
    stateOptions: stateOptions,
    areaOptions: areaOptions,
    formatCurrency: formatCurrency,
    fullAddress: fullAddress,
    displayLoc: displayLoc,
    bytes2String: bytes2String,
    log: log,
    formatBytes: formatBytes,
    formatCurrencyWithComma: formatCurrencyWithComma,
    formatDateToCustomString :formatDateToCustomString 
}

